module.exports = __webpack_public_path__ + "img/moskit.38ca03f0.svg";